module.exports = __webpack_public_path__ + "img/tjx-modal@2x.f43d5967.png";